/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IBackupQueryVariables = Types.Exact<{
  backupId: Types.Scalars['ID']['input'];
}>;

export type IBackupQuery = {
  __typename?: 'Query';
  me: { __typename?: 'Profile'; id: string; role?: Types.UserRoleEnum | null };
  backup: {
    __typename?: 'Backup';
    id: string;
    status: Types.BackupStatusEnum;
    storageRegion: string;
    disruptionNotification: Types.DisruptionNotificationEnum;
    disruptionNotificationGracePeriod?: Types.DisruptionNotificationGracePeriodEnum | null;
    versionsLimit?: number | null;
    updatedAt: any;
    name: string;
    color: string;
    description?: string | null;
    backupActivity: any;
    certificationVerified: boolean;
    reportsEnabled: boolean;
    reportsEnabledAt?: any | null;
    activatedAt?: any | null;
    createdAt: any;
    userUpdatedAt: any;
    requiredContentTypes: Array<Types.ContentTypeEnum>;
    pendingActivation: boolean;
    creator?: { __typename?: 'User'; id: string; name?: string | null } | null;
    policy: {
      __typename?: 'BackupPolicy';
      createMembers: boolean;
      enableReports: boolean;
      update: boolean;
      write: boolean;
      terminate: boolean;
      backupAssets: boolean;
      activate: boolean;
      deferActivation: boolean;
      manageCredentials: boolean;
    };
  };
};

export const BackupDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'backup' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'backupId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'me' },
            name: { kind: 'Name', value: 'profile' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backup' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'backupId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'backupId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'storageRegion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'disruptionNotification' } },
                { kind: 'Field', name: { kind: 'Name', value: 'disruptionNotificationGracePeriod' } },
                { kind: 'Field', name: { kind: 'Name', value: 'versionsLimit' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'backupActivity' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'creator' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'certificationVerified' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reportsEnabled' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reportsEnabledAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userUpdatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requiredContentTypes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pendingActivation' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'policy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'createMembers' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'enableReports' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'update' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'write' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'terminate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'backupAssets' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'activate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deferActivation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'manageCredentials' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IBackupQuery, IBackupQueryVariables>;
